export default __webpack_public_path__ + "static/media/thumb-down.36488147.png";